import logo from '../images/logo.svg'
import '../styles/header.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faBars} from '@fortawesome/free-solid-svg-icons'
import {faXmark} from '@fortawesome/free-solid-svg-icons'
import React, { useState, useEffect } from 'react';
function HeaderComponent() {

  const [toggle, setToggle] = useState(true)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); 


  useEffect(() => {
    if (windowWidth >= 668) {
      setToggle(false);
    }
  }, [toggle]);

  const toggleMenu = () =>{
    console.log(toggle)
    setToggle(!toggle)
  }

  return (
    <div className='header'>
      <div className="logo">
      <img src={logo} alt="logo" />
      </div>
      
      <div className={toggle ? 'hide-bg' : 'black-bg'}>
      <nav className={`navigation ${toggle? 'no-color' : 'white'}`}>
        <div className="burger-menu" onClick={toggleMenu}>
          {toggle ? <FontAwesomeIcon icon={faBars} className='burger'/>
                  : <FontAwesomeIcon icon={faXmark} className='x'/>}
        </div>
        {windowWidth >= 668 || !toggle ? (<ul className={toggle ? "hide-ul" : 'show-ul'}>
            <li><a href="#">home</a></li>
            <li><a href="#">shop</a></li>
            <li><a href="#">about</a></li>
            <li><a href="#">contact</a></li>
        </ul>) : null}
      </nav>
      </div>
    </div>
  )
}

export default HeaderComponent
